
<ng-container *ngIf="customer">

  <div class="header">Customer: {{customer.legalName}}</div>

  <div class="customer-detail">

  <div class="details-section">
    <div class="section-header">General</div>
    <div class="section-content">
    <div class="section-tab">
      <div class="row"><div class="col1">Legal name:</div><div class="col">{{ customer.legalName }}</div></div>
      <div class="row"><div class="col1">Local legal name:</div><div class="col">{{ customer.localLegalName }}</div></div>
      <div class="row"><div class="col1">Company's family tree level:</div><div class="col">{{ customer.familyTreeLevel }}</div></div>
      <div class="row"><div class="col1">Business Partner Type:</div><div class="col">{{ customer.businessPartnerType }}</div></div>
      <div class="row"><div class="col1">Account Type:</div><div class="col">{{  customer.accountType }}</div></div>
      <div class="row"><div class="col1">Channel:</div><div class="col">{{ customer.channel }}</div></div>
      <div class="row"><div class="col1">Industry Usage:</div><div class="col">{{ customer.industryUsage }}</div></div>
      <div class="row"><div class="col1">Active:</div><div class="col">{{ customer.active ? 'Yes' : 'No' }}</div></div>
      <div class="row"><div class="col1">Status:</div><div class="col">{{ customer.status }}</div></div>
    </div> 
    </div>

  </div>

  <ng-container *ngFor="let address of customer.address">

  <div class="details-section">
    <div class="section-header">{{ address.addressType }} Address</div>
    <div class="section-content">
    <div class="section-tab">
      <div class="row"><div class="col1">Street:</div><div class="col">{{ address.street }}</div></div>
      <div class="row"><div class="col1">City:</div><div class="col">{{ address.city }}</div></div>
      <div class="row"><div class="col1">ZIP Code:</div><div class="col">{{ address.zipCode }}</div></div>
      <div class="row"><div class="col1">Country:</div><div class="col">{{ address.country }}</div></div>
    </div> 
    </div>

  </div>

  </ng-container>

</div> 
</ng-container>